module.exports = __webpack_public_path__ + "static/media/property-manager1.98c975f9.jpg";